module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-box"
  }, [_c('VNavigator', {
    attrs: {
      "title": "关于我们"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "tab-box"
  }, [_c('li', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.setIndex,
        index: 0
      }),
      expression: "{methods:setIndex, index:0}"
    }],
    staticClass: "tab",
    class: {
      tab_select: _vm.index === 0
    }
  }, [_vm._v("\n        企业介绍\n      ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.setIndex,
        index: 1
      }),
      expression: "{methods:setIndex, index:1}"
    }],
    staticClass: "tab",
    class: {
      tab_select: _vm.index === 1
    }
  }, [_vm._v("\n        品牌故事\n      ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.setIndex,
        index: 2
      }),
      expression: "{methods:setIndex, index:2}"
    }],
    staticClass: "tab",
    class: {
      tab_select: _vm.index === 2
    }
  }, [_vm._v("\n        教育理念\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.index === 0),
      expression: "index === 0"
    }],
    staticClass: "company"
  }, [_c('p', [_vm._v("\n          瓦酷机器人是致力于3-13岁青少年的科技教育，让孩子们在“玩中学”，动手拼插 共享创新实践过程,\n          体会抽象的理论知识应用在真实的生活中。从而实现拓展思维和提升生存能力。瓦酷机器人给中国的孩子们带来最特别的教育！")]), _vm._v(" "), _c('p', [_vm._v("\n          瓦酷机器人全部应用丹麦的乐高教具。乐高的专利积木产品种类超过2000种、对产品质量要求非常高：模具公差2微米、软硬适度、超过世界上最严格的卫生标准、拼插2万次不松脱。瓦酷机器人相信通过知识延伸，构建思维和21世纪技能的培养，能够让学生积极思考、团队合作，成为终身学习者。\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          瓦酷教育学习方案根据不同年龄(3-13岁)特点设计，涉及学科内容包括科学、技术、数学、设计、社会学等，既适用于课堂教学，也可以作为课外活动和技能培训内容。瓦酷机器人将“快乐教学，创意教学”融入企业文化中。是全国机器人教育中发展最快，教育理念最优的教育基地。\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.index === 1),
      expression: "index === 1"
    }],
    staticClass: "brand"
  }, [_c('p', [_vm._v("\n          2012年，在北京东燕郊开发区开创了首家机器人培训机构，开始了我们机器人行业的探索之旅。经过4年的摸索、积累、沉淀，有了今天大家看到的瓦酷机器人创客空间的诞生。")]), _vm._v(" "), _c('p', [_vm._v("瓦酷，这个来自北京新区的企业，正向世人健步走来。她像一匹骏马，气贯长虹；她像一头劲牛，势不可挡；她像一只雄鹰，志在苍穹。四年卓绝历程，瓦酷从微不足道的加盟企业成长为志在创造机器人行业企业老大的新型品牌。")]), _vm._v(" "), _c('P', [_vm._v("\n          四年多的风风雨雨，四年多的春华秋实，瓦酷既有过创业时期的艰苦拓荒，也有过辉煌时刻的万丈豪情；既有过十字路口的彷徨抉择，也有过康庄道上的豪迈奔腾。如今，瓦酷的销售业绩稳居同行业第一，战略扩张稳步推进，市场份额遥遥领先，品牌价值不可小觑，终将成为名副其实的中国机器人培训第一品牌！")]), _vm._v(" "), _c('p', [_vm._v("\n          在新的发展阶段，瓦酷居安思危，主动求变，酝酿更高起点上的再次腾飞。文化，作为推动瓦酷前进的强大动力，也将适应环境与战略的需要，进行科学更新和发展。新时期瓦酷文化突出创新求变、超越进取的时代精神，对内凝聚人心、统一行为，对外树立形象、铸造品牌，最终使瓦酷得以永续发展，永葆基业长青。")]), _vm._v(" "), _c('p', [_vm._v("\n          在经验提炼和理念整合的基础上，瓦酷以理性和实战为基点，制订出这套文化大纲。大纲以“创新、进取、高效、自我超越”为主基调，保持瓦酷绩效导向的文化特征，牢固树立精确管理理念，融入了充满活力的新的文化因素，具有鲜明的时代特征。大纲明确了瓦酷的愿景、使命、价值观念、企业风格、战略思想、管理理念和行为理念；是瓦酷人的行动指针，是统领瓦酷各项政策、制度、规范的基础法则。每个瓦酷人都要思悟其中，行尊于思。")]), _vm._v(" "), _c('p', [_vm._v("从战略的高度上看，文化描绘企业宏图，文化指引企业航向；从发展的现实需求上看，文化激活心智模式，文化凝聚企业力量。而从最根本的意义上讲，文化铸就企业品格，文化赋予企业灵魂！\n        ")]), _c('p', [_vm._v("瓦酷（WAKOO） 延伸机器人瓦力的形象。瓦酷，快乐教学是我们的宗旨。瓦酷，将创新进行到底！")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.index === 2),
      expression: "index === 2"
    }],
    staticClass: "theory"
  }, [_vm._m(0)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('p', [_vm._v("\n            瓦酷机器人融合了“玩中学，做中学”的理论基础。并倒入了最新概念的创客意识，让孩子们再学习课程本身的同时，提升创客意识。课程的研发遵循“快乐教学，创意教学”的宗旨，旨在让孩子们“学习科技，探究科技，创新科技”为未来的学习生涯奠定坚实的基础。")]), _vm._v(" "), _c('p', [_vm._v("\n            构主义是我国当前课程改革的学习理论基础之一，是二十多年来在西方教育界流行的一股教育理论思潮，被人们称为教育上的一场“革命”。新创客机器人教育项目以建构主义作为理论基础之一，与我国课程改革方向一致，符合世界课程改革的潮流。")]), _vm._v(" "), _c('p', [_vm._v("\n            认为知识既不是客观的东西也不是主观的东西，而是个体与环境交互作用的过程逐渐构建的结果。学习是一种能动建构的过程，学习并不是个体获得越来越多外部信息的过程，而是学到越来越多的有关他们认识事物的程序即建构了新的认知方式。孩子们在解决问题时，如果能将知识同化到他已有的认知方式中，知识才不会被遗忘。")]), _vm._v(" "), _c('p', [_vm._v("\n            当孩子参与了一件自己有能力解决但是又相对具有一定挑战性任务（不难也不易）的时候，他们将全身心的投入，并具有相当的自信。新创客机器人的每一节课程的难易程度都与之符合，充分增强孩子的自信心，从而让孩子具有积极面对挫折的心态和解决问题的决心。")]), _vm._v(" "), _c('p', [_vm._v("\n            八十年代，美国着名发展心理学家、哈佛大学教授霍华德加德纳博士提出多元智能理论，二十多年来该理论已经广泛应用于欧美国家和亚洲许多国家的教育上，并且获得了极大的成功。霍华德加德纳博士指出，人类的智能是多元化而非单一的，主要是由语言智能、数学逻辑智能、空间智能、身体运动智能、音乐智能、人际智能、自我认知智能、自然认知智能等组成，每个人都拥有不同的智能优势组合。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3529b9f3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/aboutUs.vue
// module id = 769
// module chunks = 1